import { AddressBook } from "@repo/components/account/address-book";
const CheckoutAddress = ({
  address,
  selectedAddress,
  handleSelectedAddress,
  handleAddressComplete,
  session
}) => {
  return <AddressBook address={address?.content} handleSelectedAddress={handleSelectedAddress} selectedAddress={selectedAddress} isCheckout={true} session={session} handleAddressComplete={handleAddressComplete} data-sentry-element="AddressBook" data-sentry-component="CheckoutAddress" data-sentry-source-file="CheckoutAddress.jsx" />;
};
export default CheckoutAddress;